import { render, staticRenderFns } from "./JjAnnexBlock.vue?vue&type=template&id=ca40e76c&scoped=true"
import script from "./JjAnnexBlock.vue?vue&type=script&lang=js"
export * from "./JjAnnexBlock.vue?vue&type=script&lang=js"
import style0 from "./JjAnnexBlock.vue?vue&type=style&index=0&id=ca40e76c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca40e76c",
  null
  
)

export default component.exports